import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './assets/zsui/angular6827fix.m.js';

if (environment.production) {
  enableProdMode();
  window.console.log = () => { }
}

// NOTE: ngZoneEventCoalescing / ngZoneRunCoalescing were tried here for the hover/scroll
// profiling win, but they defer change detection to a requestAnimationFrame (see
// delayChangeDetectionForEvents in @angular/core). That breaks the app-wide
// `flag = false; setTimeout(() => flag = true, 0)` idiom used to force zsui <p-is-zs-select>
// widgets to re-read their <option> children: the timer fires before the rAF, so Angular never
// observes the `false` and the element is never destroyed/recreated. Left off until those
// call sites no longer depend on CD landing between the two assignments.
platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
